// TODO?: Move this into utils/cookieConsents.js

import Termly from 'termly-namespace'

import client from 'utils/client'
import CookieConsents from 'utils/cookieConsents'
import URL from 'utils/url'

import {
  setCookie,
  getCookie,
  uuidCookie,
} from 'utils/cookie'

import GTM from 'utils/gtm'
import WP from 'utils/wp'
import enableConsentScripts from 'utils/enableConsentScripts'

import buildPostPayload from './buildPostPayload'
import convertConsentSaveResponse from './convertConsentSaveResponse'
import needsFullPageReload from './needsFullPageReload'
import triggerGetUpdatedCookieWhitelistByTermly from './triggerGetUpdatedCookieWhitelistByTermly'


export default function updateCookieConsent(args) {
  const {
    acString,
    bannerSuppressed,
    cookiePolicy,
    eventType,
    consentMode,
    cookieConsent,
    tcString,
  } = args

  if ( !cookiePolicy ) {
    return () => {
      console.info('Not saving Termly consents: No cookie policy found.')
    }
  }

  const needsReload = needsFullPageReload({
    cookieConsent,
    consentMode,
  })

  return function saveCookieConsent() {
    const userCookie = getCookie(uuidCookie)

    const payload = buildPostPayload({
      acString,
      bannerSuppressed,
      cookieConsent,
      displayStyle: eventType,
      documentVersionID: cookiePolicy.published_document_version_id,
      tcString,
      templateVersionID: cookiePolicy.accepted_template_version,
      userID: userCookie,
    })

    client
      .post(URL.saveCookieConsent(), payload)
      .then(({ data }) => {
        const consents = convertConsentSaveResponse(data)

        const visitorID = consents.visitor_id

        // TODO: why are we invoking this again?
        if ( !getCookie(uuidCookie) ) {
          setCookie(uuidCookie, visitorID)
        }

        CookieConsents.setConsents(consents)

        GTM.send(cookieConsent)
        WP.send(cookieConsent)

        triggerGetUpdatedCookieWhitelistByTermly({
          consentMode,
          consentState: CookieConsents.getConsentSettings(),
          cookieConsent,
          cookies: Termly.cookies,
          visitorId: visitorID,
        })

        if ( needsReload ) {
          // A reload is how a withdrawal takes effect, and it does not happen
          // the moment we ask for it: the page keeps running until the
          // navigation commits. Drop the standing decision on the way out so
          // nothing gets released under a category that was just revoked.
          Termly.setReleaseDecision(void 0)

          window.location.reload()
        } else {
          // We are enforcing this decision in place, so the AutoBlocker has to
          // be enforcing too. An opt-out region auto-grants consent on arrival
          // and pauses it (see `shouldAutoGrant()`), and everything that loads
          // from here on answers to the choice the visitor just made.
          Termly.resumeAutoBlocker()

          const consentedCategories = Object.entries(cookieConsent)
            .filter(([category, isConsented]) => isConsented)
            .map(([category, isConsented]) => category)

          enableConsentScripts({ categories: consentedCategories })
        }
      })
      .catch((error) => {
        console.warn('[Termly] Failed to save cookie consent:', error)
      })
  }
}
